import React from 'react';
import TabContainer from '../../../../../../common/components/tab/containers/tab.containers';
import DBAIncrementalLogs from './dba-incremental-logs/containers/dba-incremental-logs';
import DBAPublishLogs from './dba-publish-logs/containers/dba-publish-logs';

export const DBACatalogLogsIndex = ({ selectedDba }: any) => {

  const tabItems = [
    {
      id: 0,
      title: 'Incremental Logs',
      component: <DBAIncrementalLogs
        selectedDba={selectedDba}
      />,
      isVisible: true,
    },
    {
      id: 1,
      title: 'Publish Logs',
      component: <DBAPublishLogs
        selectedDba={selectedDba}
      />,
      isVisible: true,
    },
  ];

  return (
    <div className="flex flex-col items-center w-full px-5 h-[620px] overflow-auto">
      <TabContainer tabItems={tabItems} />
    </div>
  );
};

export default DBACatalogLogsIndex;
